import * as React from 'react';

import { clsx } from '@freelancelabs/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    onValue?: (value: string) => void;
    error?: React.ReactNode | boolean;
}

const Textarea = (
    { value, onChange, onValue, error, disabled, className: classNameProp, ...rest }: TextareaProps,
    ref: React.Ref<HTMLTextAreaElement>
) => {
    const [focused, setFocused] = React.useState(false);
    return (
        <>
            <div
                className={clsx(
                    'input-wrapper textarea',
                    Boolean(error) && 'error',
                    focused && 'is-focus',
                    classNameProp
                )}
            >
                {/* `...rest` is spread, as `Input` already does. The props type extends
                    `TextareaHTMLAttributes`, so `id`, `name`, `rows`, `required` and every
                    `aria-*` type-check, and until this spread they were all dropped on
                    the floor. The silent casualty is the label: a page writing
                    `<label htmlFor="x">` next to `<Textarea id="x">` compiled, looked
                    right, and shipped a field no assistive technology could name. */}
                <textarea
                    aria-invalid={!!error}
                    {...rest}
                    value={value}
                    onChange={(e) => {
                        onChange?.(e);
                        onValue?.(e.target.value);
                    }}
                    onFocus={(e) => {
                        rest.onFocus?.(e);
                        setFocused(true);
                    }}
                    onBlur={(e) => {
                        rest.onBlur?.(e);
                        setFocused(false);
                    }}
                    disabled={disabled}
                    className="input"
                    ref={ref}
                />
            </div>
        </>
    );
};

export default React.forwardRef(Textarea);
